import { type Category, EnumCategory, EnumCategoryType, EnumSidebar, type Sidebar } from './types';

export const fleetCategories: Category[] = [
  {
    id: EnumCategory.VEHICLES,
    name: 'Veículos',
    label: 'Veículos',
    icon: 'truck',
    type: EnumCategoryType.ITEMS,
    color: 'primary',
    labelKey: 'label',
  },
  {
    id: EnumCategory.DRIVERS,
    label: 'Motoristas',
    icon: 'user',
    type: EnumCategoryType.ITEMS,
    color: 'warning',
    name: 'Motorista',
    labelKey: 'name',
  },
  {
    id: EnumCategory.DEVICES,
    name: 'Dispositivos',
    label: 'Dispositivos',
    icon: 'router',
    type: EnumCategoryType.ITEMS,
    color: 'accessory-purple',
    labelKey: 'cobliId',
  },
  {
    id: EnumCategory.VEHICLE_GROUPS,
    name: 'Grupos de Veículos',
    label: 'Grupos de Veículos',
    icon: 'cb-filters-vehicle-group-cb',
    type: EnumCategoryType.ITEMS,
    color: 'success',
    labelKey: 'name',
  },
];

const searchSidebar: Sidebar = [
  {
    id: EnumSidebar.ALL,
    name: 'Todos',
    hideTitle: true,
    categories: [
      {
        id: EnumCategory.ALL,
        name: 'Todos',
        label: 'Todos',
        icon: 'list-filter',
        type: EnumCategoryType.ITEMS,
        color: 'gray',
        labelKey: 'label',
      },
    ],
  },
  {
    id: EnumSidebar.FLEET,
    name: 'Dados da frota',
    categories: fleetCategories,
  },
  {
    id: EnumSidebar.DOCUMENTS,
    name: 'Documentos',
    categories: [
      {
        id: EnumCategory.IA_ARTICLES,
        loading: false,
        name: 'Busca Inteligente (IA)',
        label: 'Busca Inteligente (IA)',
        icon: 'sparkles',
        type: EnumCategoryType.IA,
        color: 'gray',
        labelKey: 'query',
      },
      {
        id: EnumCategory.ARTICLES,
        loading: false,
        name: 'Artigos',
        label: 'Artigos',
        icon: 'file-text',
        type: EnumCategoryType.ITEMS,
        color: 'gray',
        labelKey: 'title',
      },
    ],
  },
];

export default searchSidebar;
